export default {
  memoryState(state) {
    return state.memory;
  },
  submittedMemoryState(state) {
    return state.submittedMemory;
  },
  memoryLoadingState(state) {
    return state.memoryLoading;
  },
  memorySubmitLoadingState(state) {
    return state.submitLoading;
  },
};
